import { ColumnTable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { PerformanceAnalysisDetailRowModalData } from '../types';

export function useModalColumns({
  data,
}: {
  data: PerformanceAnalysisDetailRowModalData;
}): ColumnTable<any>[] {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_PERFORMANCE_ANALYSIS,
  );

  const table = useMemo(() => {
    return t<
      string,
      {
        headers: {
          studyPlanVersionName: string;
          teacherName: string;
          teacherIdentificationType: string;
          teacherIdentificationValue: string;
        };
      }
    >('tableModal', {
      returnObjects: true,
    });
  }, [t]);

  if (data.type === 'studyPlanVersions') {
    return [
      {
        columnName: 'name',
        headerText: table.headers.studyPlanVersionName,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        bold: true,
      },
    ];
  }

  if (data.type === 'teachers') {
    return [
      {
        columnName: 'name',
        headerText: table.headers.teacherName,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        bold: true,
      },
      {
        columnName: 'identificationType',
        headerText: table.headers.teacherIdentificationType,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        bold: true,
      },
      {
        columnName: 'identificationValue',
        headerText: table.headers.teacherIdentificationValue,
        tdClassName: 'text-center',
        thClassName: 'text-center',
        bold: true,
      },
    ];
  }

  return [];
}
